export default "__VITE_ASSET__BQ4n6JZI__"